export function MoneyInput({ value, onChange, className, ...props }) {
  const digits = String(value ?? '').replace(/[^0-9]/g, '');
  return (
    <input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={digits ? Number(digits).toLocaleString('id-ID') : ''}
      onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, ''))}
      onFocus={(e) => e.target.select()}
      className={className}
      {...props}
    />
  );
}
